import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { WindowRefService } from './windowRef.service';
import { lastValueFrom } from 'rxjs';

interface AdditionalParamsInterface {
  fullUrl: string;
  params: HttpParams;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private windowRefService: WindowRefService) {}

  private async buildRequestParams(path: string, additionalParams: HttpParams): Promise<AdditionalParamsInterface> {
    const fullUrl = `${this.windowRefService.LOCAL_URL}/api${path}`;
    const token = await this.token();
    const params = additionalParams.append('jwt', token);

    return { fullUrl, params };
  }

  token(): Promise<string> {
    return this.windowRefService.AP.context.getToken();
  }

  async get<T>(path: string, additionalParams: HttpParams = new HttpParams()): Promise<T | undefined> {
    const { fullUrl, params } = await this.buildRequestParams(path, additionalParams);

    const $res = this.http.get<T>(fullUrl, { params });

    return lastValueFrom($res);
  }

  async post<T>(path: string, body: object, additionalParams: HttpParams = new HttpParams()): Promise<T | any> {
    const { fullUrl, params } = await this.buildRequestParams(path, additionalParams);

    const $res = this.http.post<T>(fullUrl, body, { params });

    return lastValueFrom($res);
  }

  async put<T>(path: string, body: object, additionalParams: HttpParams = new HttpParams()): Promise<T | any> {
    const { fullUrl, params } = await this.buildRequestParams(path, additionalParams);

    const $res = this.http.put<T>(fullUrl, body, { params });

    return lastValueFrom($res);
  }

  async delete(path: string, additionalParams: HttpParams = new HttpParams()): Promise<any> {
    const { fullUrl, params } = await this.buildRequestParams(path, additionalParams);

    const $res = this.http.delete(fullUrl, { params });

    return lastValueFrom($res);
  }
}
